document.addEventListener("DOMContentLoaded", () => {
    // Locate the form and its associated table
    const form = document.querySelector("form[id*=edit_repair_approval]")
    const decisionInputWrapper = form?.querySelector("li#repair_approval_decision_input")
    const rejectionReasonInputWrapper = form?.querySelector("li#repair_approval_rejection_reason_input")
    const rejectionNotesInputWrapper = form?.querySelector("li#repair_approval_rejection_notes_input")

    if (!decisionInputWrapper || !rejectionReasonInputWrapper || !rejectionNotesInputWrapper) return

    // --- Constants ---
    const HIDDEN = "hidden"
    const DECISION_REJECTION = "rejected"
    const REJECTION_REASON_OTHER = "other"
    const DECISION_CHECKED = 'input[name="repair_approval[decision]"]:checked'
    const REJECTION_REASON_CHECKED = 'input[name="repair_approval[rejection_reason]"]:checked'

    const toggleRejectionReasonVisibility = () => {
        const selectedDecision = decisionInputWrapper.querySelector(DECISION_CHECKED)
        const rejectionReasonInputs = rejectionReasonInputWrapper.querySelectorAll("input")
        if (!selectedDecision || selectedDecision.value !== DECISION_REJECTION) {
            rejectionReasonInputWrapper.classList.add(HIDDEN)
            rejectionReasonInputs.forEach(input => input.disabled = true)

            const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
            if (selectedRejectionReason) selectedRejectionReason.checked = false
        } else {
            rejectionReasonInputs.forEach(input => input.disabled = false)
            rejectionReasonInputWrapper.classList.remove(HIDDEN)
        }

        toggleRejectionNotesVisibility()
    }

    const toggleRejectionNotesVisibility = () => {
        const selectedDecision = decisionInputWrapper.querySelector(DECISION_CHECKED)
        const selectedRejectionReason = rejectionReasonInputWrapper.querySelector(REJECTION_REASON_CHECKED)
        const rejectionNotesInput = rejectionNotesInputWrapper.querySelector("textarea")

        if (!selectedDecision) {
            rejectionNotesInputWrapper.classList.add(HIDDEN)
            rejectionNotesInput.disabled = true

            return
        }

        rejectionNotesInputWrapper.classList.remove(HIDDEN)
        rejectionNotesInput.disabled = false
        rejectionNotesInput.required = false

        if (selectedDecision.value === DECISION_REJECTION) {
            rejectionNotesInput.required = selectedRejectionReason.value === REJECTION_REASON_OTHER
        }
    }

    const addEventListeners = () => {
        // Attach event listener to the parent (event delegation)
        decisionInputWrapper.addEventListener("change", toggleRejectionReasonVisibility)
        rejectionReasonInputWrapper.addEventListener("change", toggleRejectionNotesVisibility)
    }

    const addFormEventListener = () => {
        form.addEventListener("submit", (e) => {
            const selectedDecision = decisionInputWrapper.querySelector(DECISION_CHECKED)
            if (!selectedDecision || selectedDecision.value !== DECISION_REJECTION)
                rejectionReasonInputWrapper.remove()
        })
    }

    // Initialize state on page load
    toggleRejectionReasonVisibility()
    toggleRejectionNotesVisibility()

    addEventListeners()
    addFormEventListener()
})
